var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-estimate-info-container"},[_c('span',{staticClass:"title-icon"},[_c('v-img',{staticClass:"info-icon mr-2",attrs:{"src":require(`@/assets/${_vm.whitelabel.images.insuranceEducationInfoIcon}`),"contain":""}})],1),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }